import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_386: DocMigration = {
  maxSchemaVersion: "0.0.386",
  description: "Roof base slope refactoring",
  apply(json: any) {
    const { roofs } = json;

    // roof instances
    for (const roofId in roofs) {
      const roof = roofs[roofId];

      // mark existing roofs as having legacy slope behavior
      roofs[roofId] = {
        ...roof,
        legacyRoofSlope: true,
      };
    }

    return json;
  },
};

export default migration_0_0_386;
